import React, { Component } from 'react';
import { Edit, FormDataConsumer, FormTab, TabbedForm } from 'react-admin';
import { getFormSyncErrors, getFormValues, hasSubmitFailed } from 'redux-form';
import { connect } from 'react-redux';
import ErrorIcon from '@material-ui/icons/Warning';

import CustomFormTab from '../../Common/Actions/CustomFormTab';
import AdTagsTab from './Partials/AdTagsTab';
import AdUnitsTab from './Partials/AdUnitsTab';
import SlotsTab from './Partials/SlotsTab';
import LinkedCampaignsTab from './Partials/LinkedCampaignsTab';
import SettingsTab from './Partials/SettingsTab';

import * as AccessCheck from '../../Common/Utils/AccessCheck';
import PermissionToolbar from '../../Common/Toolbar';
import PlacementTitleName from './StaticData/TitleName';
import isPresent from '../../Common/Utils/Present';
import RequiredRole from './StaticData/RequiredRole';
import Title from '../../Common/Title';
import ValidateAdUnitType from './Helpers/ValidateAdUnitType';

type Props = {
  basePath: string,
  dispatch: any,
  permissions: any,
  record: any,
  resource: string,
  submitFailed: any,
  syncErrors: any
};

class PlacementEdit extends Component<Props> {
  settingsTabErrors = () => {
    if (isPresent(this.props.syncErrors.name) || isPresent(this.props.syncErrors.account) || isPresent(this.props.syncErrors.site)) {
      return <ErrorIcon fontSize="inherit" viewBox="1 -1 22 22" style={{ color: 'red' }} />
    }
  }

  adUnitsTabErrors = () => {
    if (isPresent(this.props.syncErrors.ad_units)) {
      return <ErrorIcon fontSize="inherit" viewBox="1 -1 22 22" style={{ color: 'red' }} />
    }
  }

  slotsTabErrors = () => {
    if (isPresent(this.props.syncErrors.slots)) {
      return <ErrorIcon fontSize="inherit" viewBox="1 -1 22 22" style={{ color: 'red' }} />
    }
  }

  render() {
    const { dispatch, syncErrors, submitFailed, ...otherProps } = this.props;
    return (
      <Edit title={<Title title={PlacementTitleName} record={this.props.record} />} actions={null} {...otherProps}>
        <TabbedForm
          redirect="edit"
          toolbar={<PermissionToolbar
            accessCheck={AccessCheck.Edit(this.props.permissions, RequiredRole)}
            basePath={this.props.basePath}
            id={this.props.record && this.props.record.actual_id}
            record={this.props.record}
            resource={this.props.resource} />}
          validate={ValidateAdUnitType}>
          <CustomFormTab
            basePath={this.props.basePath}
            label={<> Settings {this.settingsTabErrors()} </>}
            record={this.props.record}
            resource={this.props.resource}
          >
            <SettingsTab record={this.props.record} resource={this.props.resource} />
          </CustomFormTab>
          <CustomFormTab
            basePath={this.props.basePath}
            label={<> Ad Units {this.adUnitsTabErrors()} </>}
            record={this.props.record}
            resource={this.props.resource}
          >
            <AdUnitsTab
              dispatch={dispatch}
              record={this.props.record}
              syncErrors={syncErrors} />
          </CustomFormTab>

          <CustomFormTab
            basePath={this.props.basePath}
            label={<> Slots {this.slotsTabErrors()} </>}
            record={this.props.record}
            resource={this.props.resource}
          >
            <SlotsTab
              dispatch={dispatch}
              record={this.props.record}
              syncErrors={syncErrors} />
          </CustomFormTab>

          <FormTab label="Linked Campaigns">
            <LinkedCampaignsTab
              basePath={this.props.basePath}
              record={this.props.record}
              resource={this.props.resource} />
          </FormTab>
          <FormTab label="Ad Tag">
            <AdTagsTab record={this.props.record} />
          </FormTab>
        </TabbedForm>
      </Edit>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    syncErrors: getFormSyncErrors('record-form')(state),
    submitFailed: hasSubmitFailed('record-form')(state),
    values: getFormValues('record-form')(state)
  }
}

export default connect(mapStateToProps)(PlacementEdit);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Edit.tsx